import {
  createBaseQueries,
  transformErrorResponse,
  transformSuccessResponse,
  EXTERNAL_URL,
} from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const { rawExternalApiBaseQuery: studentPromotionBaseQuery } = createBaseQueries({
  externalURLType: EXTERNAL_URL.sregService,
});

// These endpoints return the payload without the { status, code } wrapper,
// so the success transform runs in raw mode (still decrypts when needed).
const transformRawResponse = (response, meta, arg) =>
  transformSuccessResponse(response, meta, { ...arg, isRawResponse: true });

const studentPromotionAPI = createApi({
  reducerPath: "studentPromotionAPI",
  baseQuery: studentPromotionBaseQuery,
  tagTypes: ["StudentPromotion"],
  endpoints: (builder) => ({
    // GET — students for promotion (programmeId, branchId, semesterYearId, admissionSystem, detained, page, size, search)
    getPromotionStudents: builder.query({
      query: (params) => ({
        url: `/promotion/students`,
        method: "GET",
        params,
      }),
      transformResponse: transformRawResponse,
      transformErrorResponse: transformErrorResponse,
      providesTags: ["StudentPromotion"],
    }),

    // PUT — promote / detain / detain-to-regular (body: { uskIds: [], action, remark? })
    updateStudentPromotionStatus: builder.mutation({
      query: (body) => ({
        url: `/promotion/student-status`,
        method: "PUT",
        body,
      }),
      transformResponse: transformRawResponse,
      transformErrorResponse: transformErrorResponse,
      invalidatesTags: ["StudentPromotion"],
    }),
  }),
});

export const {
  useLazyGetPromotionStudentsQuery,
  useUpdateStudentPromotionStatusMutation,
} = studentPromotionAPI;

export default studentPromotionAPI;
